import { Injectable }                                                       from "@angular/core";
import { Response }                                                         from "@angular/http";
import { Subject }                                                          from "rxjs/Subject";
import { Observable }                                                       from "rxjs/Observable";
import { HttpDataService }                                                  from "../../../services/shared";
import { CONFIGURATION }                                                    from "../../../app.constants";
import { Banner }                       from "../../../models";
@Injectable()
export class siteAdminService {
    private totalItemsUpdate = new Subject<number>();

    constructor(private httpData: HttpDataService) {
    }

    updateConfirmed$ = this.totalItemsUpdate.asObservable();

    public confirmTotalItemUpdate(totalItems: number) {
        this.totalItemsUpdate.next(totalItems);
    }

    public GetBanner(): Observable<Response> {

        return Observable.create((observer) => {
            this.httpData.get(CONFIGURATION.baseUrls.apiUrl + "common/GetBanner")
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }

    public SaveBanner(banner: Banner): Observable<Banner> {
        return Observable.create((observer) => {
            this.httpData.post(CONFIGURATION.baseUrls.apiUrl + "common/UpdateBanner", JSON.stringify(banner))
                .map(response => <Banner>response.json().result)
                .subscribe((data) => {
                    observer.next(data);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/userHome/siteAdmin/siteAdmin.service.ts